import { css, keyframes } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import type { AlertV2Severity } from "src/components/AlertV2/AlertV2.tsx";
import { addAlphaToHex } from "src/lib/emotion/utils.ts";

const pulse = ({
  severity,
  theme,
}: {
  severity: AlertV2Severity;
  theme: ExactTheme;
}) =>
  keyframes`
    0% {
        box-shadow: 0 0 0 0 ${addAlphaToHex(
          {
            info: theme.colorsV2.blue[50],
            success: theme.colorsV2.green[50],
            error: theme.colorsV2.red[50],
            warning: theme.colorsV2.orange[50],
          }[severity],
          80,
        )};
    }
    100% {
        box-shadow: 0 0 0 20px ${addAlphaToHex(
          {
            info: theme.colorsV2.blue[50],
            success: theme.colorsV2.green[50],
            error: theme.colorsV2.red[50],
            warning: theme.colorsV2.orange[50],
          }[severity],
          0,
        )};
    }
`;
export const container =
  ({ severity, pulsate }: { severity: AlertV2Severity; pulsate: boolean }) =>
  (theme: ExactTheme) => [
    css`
      display: flex;
      border-style: solid;

      position: relative;
      overflow: hidden;
      border-width: 1px;
      border-radius: 6px;
      line-height: 165%;
      font-size: ${theme.fontSizes[1]};
      color: ${theme.colors.fg.default};
      background-color: ${{
        info: "#EEF5FE",
        success: "#EBFCF5",
        error: "#FFF7F7",
        warning: "#FFFAEF",
      }[severity]};
      border-color: ${{
        info: theme.colorsV2.blue[50],
        success: theme.colorsV2.green[50],
        error: theme.colorsV2.red[50],
        warning: theme.colorsV2.orange[50],
      }[severity]};
    `,
    pulsate &&
      css`
        animation: ${pulse({ severity, theme })} 2s infinite;
      `,
  ];

export const content = css`
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 15px;
  display: flex;
  align-items: center;
  min-width: 0;
  flex-grow: 1;
  word-break: break-word;
`;

export const closeButton = css`
  margin-top: 15px;
  margin-bottom: 15px;
  margin-right: 15px;
  height: 31px;
`;

export const statusIconContainer = css`
  margin: 15px;
  min-width: 0;
  flex-shrink: 0;
`;

export const progress =
  ({ severity, progress }: { severity: AlertV2Severity; progress: number }) =>
  (theme: ExactTheme) =>
    css({
      position: "absolute",
      height: "3px",
      transition: `transform linear 150ms`,
      bottom: 0,
      right: 0,
      left: 0,
      background: "green",
      backgroundColor: addAlphaToHex(
        {
          info: theme.colorsV2.blue[50],
          success: theme.colorsV2.green[50],
          error: theme.colorsV2.red[50],
          warning: theme.colorsV2.orange[50],
        }[severity],
        100,
      ),
      width: "100%",
      transform: `translateX(-${100 - progress}%)`,
    });
